import Vue from "vue";
import Router from "vue-router";

// 路由懒加载
const Home = () => import(/* webpackChunkName: "Home" */ "../containers/Home");

const SDK = () => import(/* webpackChunkName: "SDK" */ "../containers/SDK");
const Case = () => import(/* webpackChunkName: "Case" */ "../containers/Case");
const Products = () => import(/* webpackChunkName: "Products" */ "../containers/Products");

Vue.use(Router);

const router = new Router({
    mode: "history",
    routes: [
        {
            path: "/",
            component: Home,
            meta: {
                title: "GVoice游戏语音",
            },
        },
        {
            path: "/sdk",
            component: SDK,
            meta: {
                title: "客户端SDK下载",
            },
        },
        {
            path: "/case",
            component: Case,
            meta: {
                title: "案例-GVoice游戏语音",
            },
        },
        {
            path: "/product",
            component: Products,
            meta: {
                title: "GVoice游戏语音",
            },
        },
    ],
});

router.beforeEach((to, from, next) => {
    document.title = to.meta.title || "GVoice游戏语音";
    next();
});

export default router;
